import { createFileRoute } from '@tanstack/react-router'

import { isTravellerStatusFilter } from '#pages/MyETickets/helpers'
import type { TTravellerStatusFilter } from '#pages/MyETickets/interfaces'

interface IMyETicketsSearch {
  travellerStatus?: TTravellerStatusFilter
  page?: number
}

export const Route = createFileRoute('/_authenticated/my/e-tickets')({
  validateSearch: (search: Record<string, unknown>): IMyETicketsSearch => ({
    travellerStatus:
      typeof search.travellerStatus === 'string' && isTravellerStatusFilter(search.travellerStatus)
        ? search.travellerStatus
        : undefined,
    page: Number(search.page) > 1 ? Number(search.page) : undefined,
  }),
})
